import { defineRule } from "vee-validate";

export default defineNuxtPlugin((nuxtApp) => {
  const { t } = nuxtApp.$i18n.global;

  defineRule("required", (value: string, parameters, context) => {
    if (!value || (Array.isArray(value) && value.length === 0))
      return t("app.form.rules.required", { field: context.field });

    return true;
  });

  defineRule("email", (value: string, parameters, context) => {
    if (!value || /^[\w!#$%&'*+./=?^`{|}~-]+@[\d.A-Za-z-]+$/gm.test(value))
      return true;

    return t("app.form.rules.email", { field: context.field });
  });

  defineRule("lte", (value: number, [max]: [number | undefined], context) => {
    if (max === undefined || value <= max) return true;

    return t("app.form.rules.lte", { field: context.field, max });
  });

  defineRule("gte", (value: number, [min]: [number | undefined], context) => {
    if (min === undefined || value >= min) return true;

    return t("app.form.rules.gte", { field: context.field, min });
  });
});
